import type { Mandate } from "creso-core/types";
import { V2Loader } from "web-design-system";
import { MandateItem } from "./mandate-item";

interface Props {
  mandates?: Mandate[];
  isLoading: boolean;
  isNotifying?: boolean;
  isAuthorizing?: boolean;
  /** Advisor action: emails the investor an authorisation link. */
  onNotify?: (mandate: Mandate) => void;
  /** Investor action: sends the current user to their bank to authorise. */
  onSelfAuthorize?: (mandate: Mandate) => void;
  onSelect?: (mandate: Mandate) => void;
  onDownload?: (mandate: Mandate) => Promise<void>;
  onDelete?: (mandate: Mandate) => Promise<void>;
  emptyMessage?: string;
}

/**
 * The mandates themselves. Header and footer chrome is left to the host, since
 * partners hangs its refresh and create actions off a page layout while the
 * clients dialog renders them inline.
 */
export function MandateList({
  mandates,
  isLoading,
  isNotifying = false,
  isAuthorizing = false,
  onNotify,
  onSelfAuthorize,
  onSelect,
  onDownload,
  onDelete,
  emptyMessage = "No mandates found. Please create new one.",
}: Props) {
  return (
    <div className="flex flex-col gap-2 w-full flex-1">
      <V2Loader isLoading={isLoading}>
        <div className="flex flex-col flex-1">
          {mandates?.map((mandate) => (
            <MandateItem
              key={mandate.id}
              className="py-5 first-of-type:pt-0 border-b border-border last-of-type:border-b-0"
              mandate={mandate}
              isNotifying={isNotifying || isAuthorizing}
              onAuthorize={onNotify ? () => onNotify(mandate) : undefined}
              onSelfAuthorize={
                onSelfAuthorize ? () => onSelfAuthorize(mandate) : undefined
              }
              onSelect={onSelect}
              onDownload={onDownload}
              onDelete={onDelete}
            />
          ))}
          {mandates?.length === 0 && (
            <div className="flex flex-col items-center justify-center gap-2 h-full">
              <h6 className="text-center">{emptyMessage}</h6>
            </div>
          )}
        </div>
      </V2Loader>
    </div>
  );
}
